import { useGetAlbumVideoLazy } from '@vimeo/gctl-api/hooks/useAlbumVideo';
import { useViewer } from '@vimeo/viewer';

import { useAlbumStore } from '../state/albumStore';
import { VIDEOS_API_VERSION } from '../utils/constants';

export const useGetShowcaseVideoUserTotalVideos = (clipId: string | null) => {
  const viewer = useViewer();

  const [getAlbumVideoData, state] = useGetAlbumVideoLazy();

  const { albumId, password, isShowcaseEmbedded, referrer } = useAlbumStore((state) => ({
    albumId: state.albumId,
    password: state.hashedPass,
    isShowcaseEmbedded: state.isShowcaseEmbedded,
    referrer: state.referrer,
  }));

  const onGetTotalVideos = () => {
    if (!viewer || !clipId) return null;

    const embedQuery = {
      isEmbed: isShowcaseEmbedded,
      referrer,
    };

    getAlbumVideoData({
      where: { albumId, videoId: clipId as unknown as number },
      select: ['user.metadata.publicVideos.total'],
      query: {
        /**
         * `fetchUserProfile: 1` is needed to enable `user.metadata.publicVideos.total`
         * ref:
         * https://github.com/vimeows/vimeo/blob/d37ba527dc358629be3160bc926d94c6cf3c7a2e/src/Vimeo/Api/Response/UserResponse.php#L145C10-L145C33
         * https://github.com/vimeows/vimeo/blob/d37ba527dc358629be3160bc926d94c6cf3c7a2e/src/Vimeo/Api/Response/UserResponse.php#L1211-L1223
         */
        // @ts-expect-error the fetchUserProfile is on userResponsible which is included in clip response
        fetchUserProfile: '1',
        ...embedQuery,
        ...(password && { password }),
      },
      headers: { Accept: `application/vnd.vimeo.*+json;version=${VIDEOS_API_VERSION}` },
    });
  };

  return { onGetTotalVideos, ...state };
};
